import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class NetworkInfoProvider {

  constructor(public http: Http) {
    
  }

  public async isConnected(): Promise<boolean> {
    var result = await this.http.get('https://google.com').toPromise();
    return result.ok;
  }

}



// WEBPACK FOOTER //
// ./src/providers/network-info/network-info.ts